import RoomsTab from './RoomsTab'
export default RoomsTab


// WEBPACK FOOTER //
// ./src/components/ChannelTabs/OmnitecTab/MappingTabs/RoomsTab/index.js